module.exports = (__webpack_require__("bricks/next-builder:/8r5"))("qJlv");